import React from "react";
import { FaWhatsapp, FaUsers, FaComments, FaBell } from "react-icons/fa";
import { WHATSAPP_COMMUNITY_URL } from "../../../constants/appLinks";
import { WHATSAPP_COMMUNITY_QR } from "../../../constants/appImages";
import "./CommunitySection.css";

const perks = [
  { icon: FaUsers, text: "Network with CA, CS & CMA professionals" },
  { icon: FaComments, text: "Share insights and career updates" },
  { icon: FaBell, text: "Stay in the loop on opportunities" },
];

const CommunitySection = () => {
  return (
    <section className="community-section" aria-label="Join WhatsApp community">
      <div className="community-container">
        <div className="community-card">
          <div className="community-qr-wrap">
            <img
              src={WHATSAPP_COMMUNITY_QR}
              alt="Scan to join CAJobPortal WhatsApp community"
              className="community-qr"
              loading="lazy"
            />
            <span className="community-scan-hint">Scan to join</span>
          </div>

          <div className="community-content">
            <span className="community-eyebrow">WhatsApp Community</span>
            <h2 className="community-title">
              Connect with <span className="community-highlight">CA professionals</span>
            </h2>
            <p className="community-subtitle">
              Join our community for job updates, career discussions, and peer support
              from across India.
            </p>

            <ul className="community-perks">
              {perks.map(({ icon: Icon, text }) => (
                <li key={text}>
                  <Icon aria-hidden="true" />
                  <span>{text}</span>
                </li>
              ))}
            </ul>

            <a
              href={WHATSAPP_COMMUNITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="community-cta"
            >
              <FaWhatsapp aria-hidden="true" />
              Join WhatsApp Community
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
